(() => {
  if (window.torqueQWordmark) return;
  window.torqueQWordmark = true;
  const excluded = 'script,style,textarea,input,select,option,svg,math,pre,code,[contenteditable],.tq-brand-q,.tc-hero .tt-intro,.tc-hero__actions .tt-button';
  const pattern = /\bQ(?=[\-\u2011\u2013\s]?lens\b)/gi;
  const brand = root => {
    const nodes = [];
    const visit = node => {
      if (!node.parentElement || !node.parentElement.closest('.tc-hero') || node.parentElement.closest(excluded)) return;
      pattern.lastIndex = 0;
      if (pattern.test(node.data)) nodes.push(node);
    };
    if (root.nodeType === Node.TEXT_NODE) visit(root);
    else if (root.nodeType === Node.ELEMENT_NODE && !root.closest(excluded)) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) visit(walker.currentNode);
    }
    for (const node of nodes) {
      const fragment = document.createDocumentFragment();
      let start = 0;
      pattern.lastIndex = 0;
      for (const match of node.data.matchAll(pattern)) {
        fragment.append(document.createTextNode(node.data.slice(start, match.index)));
        const mark = document.createElement('span');
        mark.className = 'tq-brand-q';
        const text = document.createElement('span');
        text.textContent = match[0];
        mark.append(text);
        fragment.append(mark);
        start = match.index + 1;
      }
      fragment.append(document.createTextNode(node.data.slice(start)));
      // Keep the original text as one flex item in buttons and navigation links.
      const copy = document.createElement('span');
      copy.className = 'tq-brand-copy';
      copy.append(fragment);
      node.replaceWith(copy);
    }
  };
  const start = () => {
    brand(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') brand(record.target);
        else record.addedNodes.forEach(brand);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
